
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private enabled = signal(true);

  constructor() {
    // Expose logging control to window for runtime debugging in production
    if (typeof window !== 'undefined') {
      (window as any).enableLogging = (enable: boolean) => this.toggleLogging(enable);
      (window as any).isLoggingEnabled = () => this.enabled();
    }
  }

  toggleLogging(isEnabled: boolean) {
    this.enabled.set(isEnabled);
  }

  isLoggingEnabled(): boolean {
    return this.enabled();
  }

  debug(message: string, ...args: unknown[]) {
    if (this.enabled()) {
      console.debug(`[DEBUG ${new Date().toISOString()}]: ${message}`, ...args);
    }
  }

  log(message: string, ...args: unknown[]) {
    if (this.enabled()) {
      console.log(`[LOG ${new Date().toISOString()}]: ${message}`, ...args);
    }
  }

  warn(message: string, ...args: unknown[]) {
    if (this.enabled()) {
      console.warn(`[WARN ${new Date().toISOString()}]: ${message}`, ...args);
    }
  }

  error(message: string, ...args: unknown[]) {
    if (this.enabled()) {
      console.error(`[ERR ${new Date().toISOString()}]: ${message}`, ...args);
    }
  }
}
